import React from 'react'

import {
  Box,
  Button,
  Icon,
  SearchField,
  Text,
  Touchable,
} from '@factorialco/deprecated-design-system'
import { orderBy } from 'lodash'

import BoxList from 'modules/core/components/BoxList'
import type { Field } from 'modules/core/components/EmployeeMultiFilters/commonInterfaces'
import ScrollableList from 'modules/core/components/ScrollableList'
import createComputed from 'modules/core/hooks/createComputed'
import useSearch from 'modules/core/hooks/useSearch'
import i18n from 'modules/core/lib/i18n'
import { matchText } from 'modules/core/lib/stringUtils'

import './index.styles.css'
interface Props {
  header: string
  reset?: string
  icon?: React.ComponentProps<typeof Icon.Small>['icon']
  onClickHeader: () => void
  getFields: () => Field[]
}

const ASC = 'asc'
type SortDirection = typeof ASC

const useComputedFields = createComputed((fields, search: string, direction: SortDirection) => {
  const templatesToDisplay = fields.filter((field: Field) => {
    return matchText(search, field.title)
  })

  return orderBy(templatesToDisplay, (field) => field.title, [direction])
})

const BlankList = () => {
  return (
    <Box alignItems="center" padding="s40" width="full">
      <Text.Normal>{i18n.t('filters.default_filters.filter_not_found')}</Text.Normal>
    </Box>
  )
}

const FieldOptions = ({ field }: { field: Field }) => {
  return (
    <Box
      style={{ maxHeight: '256px' }}
      alignItems="center"
      justifyContent="flexStart"
      cursor="pointer"
      flexDirection="row"
      padding="s16"
      width="full"
      onClick={() => field.onClick()}
      className={field.selected ? '_DefaultPopOver_itemSelected' : '_DefaultPopOver_item'}
      textAlign="left"
    >
      <Text.Normal weight="medium" color={field.selected ? 'viridian1200' : 'grey800'} ellipsis>
        {field.title}
      </Text.Normal>
    </Box>
  )
}

const DefaultPopOver = ({ header, onClickHeader, reset, icon, getFields }: Props) => {
  const { search, onSearch } = useSearch()
  const computedFields: Field[] = useComputedFields(getFields(), search, ASC).get()
  const fields: Field[] = reset ? getFields() : computedFields

  return (
    <Box padding="s32" gap="s16">
      <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center">
        <Box flexDirection="row" alignItems="center">
          {icon && (
            <Touchable onClick={onClickHeader}>
              <Box paddingRight="s16">
                <Icon.Small icon={icon} color="grey800" />
              </Box>
            </Touchable>
          )}
          <Text size="300" weight="medium" color="grey1000">
            {header}
          </Text>
        </Box>
        {reset && (
          <Button type="secondary" onClick={onClickHeader}>
            {reset}
          </Button>
        )}
      </Box>
      <BoxList>
        {!reset && (
          <Box width="full" flexDirection="row" background="grey200" padding="s8">
            <Box flexGrow>
              <SearchField
                variant="big"
                search={search}
                onSearch={onSearch}
                placeholder={i18n.t('common.search')}
                autofocus
              />
            </Box>
          </Box>
        )}
        <ScrollableList size="small">
          {!reset && !computedFields.length && <BlankList />}
          {fields.map((field, idx) => (
            <FieldOptions field={field} key={`${field.title}${idx}`} />
          ))}
        </ScrollableList>
      </BoxList>
    </Box>
  )
}

export default DefaultPopOver
